export class FindingCountEntry {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "detectorType",
            "baseName": "detectorType",
            "type": "FindingCountEntryDetectorTypeEnum",
            "format": ""
        },
        {
            "name": "evidenceType",
            "baseName": "evidenceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "evidenceDisplayName",
            "baseName": "evidenceDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return FindingCountEntry.attributeTypeMap;
    }
    constructor() {
    }
}
export var FindingCountEntryDetectorTypeEnum;
(function (FindingCountEntryDetectorTypeEnum) {
    FindingCountEntryDetectorTypeEnum["Malware"] = "MALWARE";
    FindingCountEntryDetectorTypeEnum["RansomwareBehavior"] = "RANSOMWARE_BEHAVIOR";
    FindingCountEntryDetectorTypeEnum["DataAnomaly"] = "DATA_ANOMALY";
})(FindingCountEntryDetectorTypeEnum || (FindingCountEntryDetectorTypeEnum = {}));
